import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

const NotFoundPage: React.FC = () => {  
  const { t } = useTranslation();

  return (
    <Result
      status="404"
      title={t('login.pageNotFoundTitle')}
      subTitle={t('login.pageNotFoundTip')}
      extra={<Button type="primary" onClick={() => window.location.href = '/'}>{t('login.goToBackHome')}</Button>}
    />
  )
}  
  
export default NotFoundPage;